"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgEarlyArrival = function SvgEarlyArrival(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.849 8.549v-2.01a2.476 2.476 0 0 0-3.363-2.311c-1.017.39-1.813 1.237-1.978 2.313-.221 1.44-.222 2.863.022 4.122M8.849 8.55c4.394 0 6.046.566 9.563 4.024-1.434.743-3.624 1.436-5.554 1.113M8.85 8.549c.358 3.434 2.05 4.81 4.01 5.137M8.85 8.549l-5.32 2.114m9.33 3.023c-5.707 3.025-8.603.726-9.33-3.023",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.933,
    cy: 6.604,
    fill: "#4D4D4D",
    r: 0.727
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.892 7.812 1.92-1.019-1.99-.7.07 1.719Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.623 14.59.93.906-1.427 3.164M8.59 15.08l-1.516 3.33m7.021-11.908A1.167 1.167 0 1 1 12.3 5.01a1.167 1.167 0 0 1 1.794 1.492Zm1.704-3.6-1.206 1.324m2.314 4.149-2.21-1.263m-3.081-2.609L9.75 3.038m3.208.632-.185-1.712m4.28 3.75h-1.78",
    stroke: "#4D4D4D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgEarlyArrival);
var _default = exports["default"] = Memo;